import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Empty } from 'antd';
import { t } from '../../i18n/i18n';
import './TableCustomEmails.scss';

import { setCustomEmails } from '../../redux/actions/customEmailsActions';
import Spinner from '../spinner/Spinner';
import InfiniteScroll from '../InfiniteScroll/InfiniteScroll';

export const TableCustomEmails = ({
  fetchDataTable,
  onClickSendMail,
  setHeaders,
  headers,
  defaultTemplate,
}) => {
  const dispatch = useDispatch();
  const customEmails = useSelector((state) => state.customEmails.customEmailsPaginated) || {};
  const quantity = useMemo(
    () => customEmails?.list?.filter((item) => item?.checked)?.length,
    [customEmails?.list]
  );
  const [stopLoad, setStopLoad] = useState(false);

  const hasFilter = useMemo(() => {
    const { workspaceIds, ...rest } = customEmails?.filter || {};
    return Object.keys(rest).length > 0;
  }, [customEmails?.filter]);

  const onCheckRow = (elements) => {
    dispatch(setCustomEmails({ ...customEmails, list: elements }));
  };

  const init = async () => {
    await fetchDataTable(0, {}, true);
  };

  useEffect(() => {
    init();
  }, []);

  const loadMoreData = async () => {
    if (stopLoad || customEmails?.isLoading || customEmails?.reload) return;
    await fetchDataTable(customEmails?.pagination?.offset + 1, customEmails?.filter);
  };

  const handleSort = async (headerKey, order) => {
    let sortName = headerKey === 'candidate' ? 'firstName' : headerKey;
    if (headerKey === 'contacted') {
      sortName = 'comunications.sendDate';
    }
    await fetchDataTable(0, { ...customEmails?.filter, orderBy: order, sort: sortName });
  };

  const onClickHeader = async (header) => {
    setStopLoad(true);
    await handleSort(header?.key, header?.order);
    setHeaders(headers?.map((item) => (item?.key === header?.key ? header : item)));
    setStopLoad(false);
  };

  const cleanFilters = async () => {
    setStopLoad(true);
    await fetchDataTable(0, {});
    setStopLoad(false);
  };

  const columns = [
    {
      title: t('TITLE'),
      dataIndex: 'title',
      key: 'title',
      width: '30%',
      ellipsis: true,
      className: 'text-truncate',
    },
    {
      title: t('SUBJECT'),
      dataIndex: 'subjectTranslated',
      key: 'subjectTranslated',
      width: '30%',
      ellipsis: true,
      className: 'text-truncate',
    },
    {
      title: t('TYPE'),
      dataIndex: 'typeColumn',
      key: 'typeColumn',
      width: '15%',
      responsive: ['md'],
    },
    {
      title: t('SEND_TYPE'),
      dataIndex: 'sendTypeColumn',
      key: 'sendTypeColumn',
      width: '15%',
      responsive: ['lg'],
    },
    {
      title: t('ACTIONS'),
      dataIndex: 'actions',
      key: 'actions',
      width: '10%',
      align: 'right',
      className: 'text-right',
    },
  ];

  return (
    <div className="custom-emails-table-container">
      <div className="container-fluid bg-white rounded-bottom px-4 pb-4 pt-0">
        {!customEmails?.reload ? (
          <Table
            columns={columns}
            dataSource={customEmails?.list || []}
            loading={customEmails?.isLoading}
            rowKey={(record) => record.id || record._id}
            pagination={false}
            scroll={{ x: true }}
            locale={{
              emptyText: (
                <Empty
                  description={
                    <div>
                      <p className="mb-1">{t('EMAILS_EMPTY_ROW')}</p>
                      <small className="text-muted">{t('EMAILS_EMPTY_DESCRIPTIONS')}</small>
                    </div>
                  }
                />
              ),
            }}
            className="custom-emails-antd-table"
          />
        ) : (
          <Spinner show={customEmails?.reload} />
        )}
        <InfiniteScroll
          onScrollEnd={() => {
            if (!stopLoad) {
              loadMoreData();
            }
          }}
          isLoading={customEmails?.isLoading}
        />
      </div>
    </div>
  );
};
